// Presentation remotes are just keyboards: most send PageDown/PageUp, some
// arrows. Anything else (F5/Esc/"." for black screen...) is left alone.
const FORWARD = ['PageDown', 'ArrowRight', 'ArrowDown', ' ', 'Enter'];
const BACK = ['PageUp', 'ArrowLeft', 'ArrowUp', 'Backspace'];
// Cheap remotes can double-fire a single click.
const MIN_INTERVAL_MS = 350;

export function presenterDirection(key) {
    if (FORWARD.includes(key)) return 1;
    if (BACK.includes(key)) return -1;
    return 0;
}

// Calls onStep(+1|-1) for every remote click while isEnabled() holds.
// Returns the function that removes the listener.
export function startPresenterRemote({ target = globalThis, isEnabled, onStep, now = () => Date.now() }) {
    let last = -Infinity;
    function onKeyDown(event) {
        if (event.repeat || event.altKey || event.ctrlKey || event.metaKey) return;
        const tag = event.target?.tagName;
        if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || event.target?.isContentEditable) return;
        const direction = presenterDirection(event.key);
        if (!direction || !isEnabled()) return;
        // Space/arrows would otherwise also scroll the page underneath.
        event.preventDefault();
        if (now() - last < MIN_INTERVAL_MS) return;
        last = now();
        onStep(direction);
    }
    target.addEventListener('keydown', onKeyDown);
    return () => target.removeEventListener('keydown', onKeyDown);
}
